module.exports = __webpack_public_path__ + "img/google_logo.d555d0ac.png";